import { regularApiClient } from "../utils/kiota-client";
import type { ProductDto } from "../../../RoyalFloraHolland.Aap.Services.Api.Web.Kiota/Typescript/Api/models/index";

export interface ProductDetailResult {
  data?: ProductDto | null;
  error?: {
    message: string;
    statusCode?: number;
  };
}

/**
 * Loads a single product detail from the API using the Kiota client
 */
export async function loadProductDetail(
  productId: string,
): Promise<ProductDetailResult> {
  console.log(
    "[productDetailService] Loading product details for ID:",
    productId,
  );
  try {
    const id = parseInt(productId, 10);

    if (isNaN(id)) {
      console.error("[productDetailService] Invalid product ID:", productId);
      return {
        error: {
          message: "Invalid product ID",
          statusCode: 400,
        },
      };
    }

    console.log("[productDetailService] Calling API with numeric ID:", id);
    const response = await regularApiClient.api
      .vWithVersion("1")
      .products.byId(id)
      .get({
        queryParameters: {
          includeAll: true,
        },
      });

    console.log("[productDetailService] API response:", response);

    if (!response) {
      return {
        data: null,
      };
    }

    return {
      data: response,
    };
  } catch (error: unknown) {
    console.error("Error loading product detail:", error);

    const err = error as { statusCode?: number; message?: string };
    const statusCode = err.statusCode;
    const message = err.message || "Failed to load product details";

    return {
      error: {
        message,
        statusCode,
      },
    };
  }
}
